import React, { useEffect } from 'react';
import {
  AppBarProps,
  MenuItemLink,
  SidebarToggleButton,
  useSidebarState,
} from 'react-admin';
import { useTheme } from '@mui/material/styles';
import {
  AppBar as MuiAppBar,
  Box,
  Stack,
  Toolbar,
  useMediaQuery,
  Theme,
} from '@mui/material';
import COCUserMenu from './COCUserMenu';
import { ExitToApp, Face, VpnKey } from '@mui/icons-material';
import { LLButton, LLLink } from '@/components-library';
import UpdateAvatar from '../pages/user/edit/UpdateAvatar';
import COCBreadcrumb from './COCBreadcrumb';
import { sidebar } from '../theme/theme';
import COCNotifications from './notifications/COCNotifications';
import CommonEmployerChooseInput from '../components/inputs/CommonEmployerChooseInput';
import CommonClubChooseInput from '../components/inputs/CommonClubChooseInput';
import LogoutIcon from '@mui/icons-material/Logout';
import { Resources } from '@/src/shared/constants/resources';

const COCAppBar = (props: AppBarProps) => {
  const [sidebarOpen] = useSidebarState();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const theme = useTheme();

  const sx = {
    root: {
      width: sidebarOpen
        ? `calc(100% - ${sidebar.width}px)`
        : `calc(100% - ${sidebar.closedWidth}px)`,
      transition: 'width .195s cubic-bezier(0.4, 0, 0.6, 1)',
      backgroundColor: 'info.100',
      color: theme.palette.getContrastText(theme.palette.info[100]),
      height: '64px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        pl: 2,
        pr: '0 !important',
        height: '100px',
      },
    },
    toolBar: {
      pr: '24px',
      [theme.breakpoints.down('sm')]: {
        pr: '16px',
        pt: '16px',
      },
    },
    title: {
      flex: 1,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        fontSize: '20px',
      },
    },
    notifications: {
      ml: 'auto',
    },
    menuItem: {
      // color: 'info.900',
      py: 0,
      px: 2,
      mx: 2,
      my: 0.5,
      width: '86%',
      borderRadius: '12px',
    },
    menuItemIcon: {
      color: 'info.900',
    },
  };

  const {
    children,
    className,
    open,
    title,
    userMenu,
    container: Container,
    ...rest
  } = props;

  const [openAvatarModal, setOpenAvatarModal] = React.useState(false);
  const handleOpenAvatarModal = () => setOpenAvatarModal(true);
  const handleCloseAvatarModal = () => setOpenAvatarModal(false);

  return (
    <>
      <UpdateAvatar open={openAvatarModal} handleCloseModal={handleCloseAvatarModal} />
      <MuiAppBar elevation={0} sx={sx.root}>
        <Toolbar variant="regular" sx={sx.toolBar}>
          {isMobile ? (
            <Box>
              <LLButton
                color="inherit"
                variant="outlined"
                sx={{ borderRadius: '24px', minWidth: '42px', p: 0, ml: -1, mr: 2 }}
              >
                <SidebarToggleButton />
              </LLButton>
            </Box>
          ) : null}
          <Stack
            direction={isMobile ? 'column-reverse' : 'row'}
            flex={1}
            alignItems={isMobile ? 'flex-end' : 'center'}
          >
            <COCBreadcrumb sx={sx.title} />
            {/*todo: can be added if we need to switch clubs*/}
            {/*<CommonClubChooseInput />*/}
            {/*todo: can be added if we need to switch users*/}
            <CommonEmployerChooseInput sx={{ m: 0, mt: -0.2, mx: 1 }} />
            {/*<COCNotifications sx={sx.notifications} />*/}
            <COCUserMenu>
              <LLLink to={`/${Resources.ClubProfile}`}>
                <LLButton sx={[sx.menuItem, { color: 'common.black' }]} variant="text">
                  Profile
                </LLButton>
              </LLLink>
              <div>
                <LLButton
                  sx={[sx.menuItem, { color: 'common.black' }]}
                  variant="text"
                  onClick={(e) => {
                    e.preventDefault();
                    handleOpenAvatarModal();
                  }}
                >
                  Update avatar
                </LLButton>
              </div>
              <LLLink to={`/logout`}>
                <LLButton sx={sx.menuItem} variant="contained">
                  Sign out
                </LLButton>
              </LLLink>
              {/*<MenuItemLink*/}
              {/*  sx={sx.menuItem}*/}
              {/*  to="/logout"*/}
              {/*  leftIcon={<LogoutIcon sx={sx.menuItemIcon} />}*/}
              {/*  primaryText="Sign out"*/}
              {/*/>*/}
            </COCUserMenu>
          </Stack>
        </Toolbar>
      </MuiAppBar>
    </>
  );
};

export default COCAppBar;
